import Cookies from 'js-cookie';
import appConfig from 'appConfig';
import {
  propertySearch,
  shpSearch,
  getCheckSql,
  glandServer,
  exportTYExcel,
  outPutSearchInfo,
} from '@/api/index';
export default {
  name: 'BottomProperty',
  components: {},
  data() {
    return {
      currentChoose: '', //过滤图层标识
      columnsSelect: [
        {
          title: '选择',
          key: 'id',
          width: 60,
          align: 'center',
          render: (h, params) => {
            let id = params.row.id;
            let flag = false;
            if (this.currentChoose === id) {
              flag = true;
              //调用查询
            } else {
              flag = false;
            }
            let self = this;
            return h('div', [
              h('Radio', {
                props: {
                  value: flag,
                },
                on: {
                  'on-change': () => {
                    self.currentChoose = id;
                    this.contextData = params.row;
                    if (this.contextData) {
                      this.spinshow = true;
                      this.commonAnalysis();
                      this.$emit('current_map', this.contextData, 1);
                      this.spinshow = false;
                    }
                  },
                },
              }),
            ]);
          },
        },
        {
          title: '图层名称',
          key: 'title',
          width: 80,
          align: 'center ',
        },
      ],
      dataSelect: [],
      columns1: [],
      data134: [],
      bottomShow: false,
      spinshow: false, //加载中
      Featurecollection: [], //当前分页加载的数据
      FeatureAll: [], //全部数据
      contextData: {}, //当前选中的图层
      pageinfo: {
        count: 100, //总条数
        pagesize: 10, //每页显示的条数
        current: 6, //当前页码
      },
      hidebottom: false, //false表示不收缩，true表示收缩
      analysis: false, //是否是压盖分析结果
      analysisdl: false, //是否是地类分析
      noRelation: false, //跟查询没关系的状态
      onlyExport: false, //只有导出按钮状态，根据前端查询arcgis
      onlyExportxzjc: false, //只有导出按钮状态，根据前端查询arcgis
      savelayerstatus: {
        status: false,
        loading: false,
      }, //是否保存图层
      filtershow: false, //二次过滤条件展示
      filter: [
        '=',
        '<>',
        '>',
        '>=',
        '<',
        '<=',
        '%',
        '0',
        'like',
        'is',
        '空',
        '非空',
        'and',
        'or',
        'not',
      ],
      filterfieldArr: [],
      columns_filter: [
        {
          title: '字段名称',
          key: 'name',
        },
        {
          title: '字段别名',
          key: 'alias',
        },
      ],
      data_filter: [],
      columns_val: [
        {
          title: '属性值',
          key: 'val',
          align: 'center',
        },
      ],
      data_val: [],
      layertitle: '',
      filtercondition: {
        fild: '', //字段
        operator: '', //运算符
        value: '', //属性值
        Where: '', //条件
        type: '', //字段类型
        layerfilterid: '', //当前图层id
      },
      applyloading: false, //应用按钮loading
      exportloading: false, //导出结果按钮
      shploading: false, //导出结果按钮
      pagetotal: 0,
      isClose: true,
      dataparams: {}, //查询条件
      dataparam_exp: {}, //导出按照分页查询条件
      spintj: false, //唯一值获取加载中
      showStatus: true, //true,按钮为过滤显示，false,按钮为完整显示
      FeatureAlysis: [],
      titles: '',
      addShow: false, //追加弹窗
      columns2: [],
      addTableData: [],
      propertyArr: [],
      drawGrid: {
        geometry: '',
        polygonWKT: '',
        polygonJson: [],
        feature: null,
      },
      byOBJECTId: '',
      totalField: [], //属性字段类型
      fieldsList: [], //传入别名
      isExportShp: false,
      overlay: null,
      queryType: '',
      outPutFileParams: {
        id: '',
        url: '',
        layername: '',
        tableName: '',
        cql: '',
      },
      filterArr: [],
    };
  },
  props: {
    featureData: {
      type: Array,
      default: () => { },
    },
  },
  watch: {
    featureData(newV, oldV) {
      // watch监听props里status的变化，然后执行操作
      this.getDataShow(newV[0], newV[1]);
    },
  },
  created() {
    this.confmap = appConfig.map;
    let roles = JSON.parse(localStorage.getItem('userInfo')).roles;
    this.isExportShp = roles[0].isExportShp == null ? false : roles[0].isExportShp;
  },
  methods: {
    bottomhideClick() {
      // 收缩
      if (this.hidebottom) {
        this.hidebottom = false; //展开
      } else {
        this.hidebottom = true; //收起
      }
    },
    bottomRemoveClick() {
      // 关闭
      // var source = this.olmap.zxQueryLayer.getSource();
      // source.clear();
      this.FeatureAll = [];
      this.FeatureAlysis = [];
      this.Featurecollection = [];
      this.layertitle = '';
      this.columns1 = [];
      this.data134 = [];
      // 翻页清空
      this.pageinfo.count = 0;
      this.pageinfo.pagesize = 10;
      this.pageinfo.current = 1;
      this.filtercondition.Where = '';
      this.bottomShow = false;
      // 清除弹框
      var pops = this.olmap.zxPops;
      if (pops && pops.length > 0) {
        for (var i = 0; i < pops.length; i++) {
          pops[i].close();
        }
      }
      this.showStatus = true;
      var arr = this.olmap.getLayers().array_;
      var curid = this.contextData.id; //当前选中图层的id
      for (var i = arr.length - 1; i >= 0; i--) {
        var layer = arr[i];
        var id = layer.get('id');
        if ('_layertree_' + curid == id) {
          // 进行出图操作
          this.publicMethod.filterGeoServerLayer(layer, '1=1');
          break;
        }
      }
      this.contextData = {};
    },

    //通用压盖分析查询
    commonAnalysis(page) {
      if (!page) {
        page = 1;
      }
      // 清除弹框
      // var pops = this.olmap.zxPops;
      if (pops && pops.length > 0) {
        for (var i = 0; i < pops.length; i++) {
          pops[i].close();
        }
      }
      this.pageinfo.current = page;
      console.log(this.dataparams)
      var params = {
        typeName: this.contextData.layername,
        tableName: this.contextData.tableName,
        startIndex: (page - 1) * 10,
        maxFeatures: 10,
        coordinates: JSON.stringify(this.dataparams.pointStr),
        url: this.contextData.bufferUrl,
        geometriesParams: JSON.stringify({
          type: 'MultiPolygon',
          coordinates: [this.dataparams.jsonData],
        }),
        bufferNumber: '',
        sr: appConfig.map.proj,
        fileId: this.dataparams.fileId,
      };
      var newFeatureArr = [];
      let res = glandServer(JSON.stringify(params));
      if (res && res.recordList) {
        var recordList = res.recordList;
        if (recordList.length > 0) {
          recordList.forEach((item, index) => {
            item.geometry = item.geometrywkt ? JSON.parse(item.geometrywkt) : {};
            item.properties['压占比'] =
              (parseFloat(item.yzb ? item.yzb : 0) * 100).toFixed(2) + '%'; //删除制定数据 转为100%
            item.properties['图斑面积'] = item.tbmj;
            item.properties['压占面积'] = item.yzmj;
            var geojson_format = new this.$olmap.format.GeoJSON();
            let featureObj = geojson_format.readFeature(item.geometry);
            delete item.properties.Shape_Area; //添加制定数据
            delete item.properties.Shape_Leng;
            delete item.properties.Shape_Length;
            delete item.properties.mpArea;
            delete item.properties.mpLayer;
            delete item.properties.mpPerimete;
            if (item.properties.hasOwnProperty('geometrywkt')) delete item.properties.geometrywkt;
            if (item.properties.hasOwnProperty('st_astext')) delete item.properties.st_astext;
            if (item.properties.hasOwnProperty('the_geom')) delete item.properties.the_geom;
            featureObj.values_ = Object.assign(featureObj.values_, item.properties);
            newFeatureArr.push(featureObj);
          });
          var fea = {
            features: newFeatureArr,
            contextData: this.contextData,
            total: res.count,
            spinshow: true,
            analysis: true,
          };
          this.getDataShow_analysis(fea.features, fea.contextData, fea.total);
        } else {
          this.$Message.info('暂无数据!');
          this.getDataShow_analysis([]);
        }
      }
    },

    // 翻页触发事件
    changepage(page, byOBJECTId) {
      if (this.queryType) {
        let that = this;
        this.dataparams.pageNum = page;
        $.ajax({
          type: 'post',
          url: '/zituSpace/wps/getGeoserverQuery',
          contentType: 'application/json; charset=UTF-8',
          data: JSON.stringify(this.dataparams),
          success: function (res) {
            if (res.code == 200 && res.success) {
              let featureArr = [];
              if (res.result.features.length > 0) {
                res.result.features.forEach((item, index) => {
                  var geojson_format = new that.$olmap.format.GeoJSON();
                  let featureObj = geojson_format.readFeature(item.geometry);
                  featureObj.values_ = Object.assign(featureObj.values_, item.properties);
                  featureArr.push(featureObj);
                });
              }
              if (featureArr.length > 0) {
                that.pagetotal = res.result.totalFeatures;
                that.pageinfo.count = res.result.totalFeatures; //总条数
                that.getDataShow(featureArr, that.contextData, that.pageinfo.count);
              } else {
                that.$Message.info('暂无数据！');
              }
            }
          },
          error: function (e) { },
        });
      } else {
        var startIndex = (page - 1) * 10;
        // 判断是否是压盖分析
        if (this.analysis || this.analysisdl) {
          this.commonAnalysis(startIndex);
        } else {
          var where1 = JSON.parse(JSON.stringify(this.dataparams));
          if (this.filtercondition.Where) {
            if (this.dataparams.where) {
              where1.CqlFilter = this.dataparams.where + ' ' + 'And' + ' ' + this.filtercondition.Where;
            } else {
              where1.CqlFilter = this.filtercondition.Where;
            }
          } else {
            if (this.dataparams.where) {
              where1.CqlFilter = this.dataparams.where
            } else {
              where1.CqlFilter = ''
            }
          }
          var feas = {
            contextData: this.contextData,
            startIndex: startIndex,
            maxFeatures: 10,
            param: where1,
            tital: this.pageinfo.count,
          };
          if (byOBJECTId) {
            this.byOBJECTId = byOBJECTId;
          }
          this.spaQ_geoServer(where1, startIndex);
          this.$emit('current_map', this.contextData, page);
        }
      }
    },
    // 通用geoserver查询
    async spaQ_geoServer(where, pages) {
      console.log(where, pages);
      where.startIndex = pages; //下表赋值
      var pjsonResult = await this.publicMethod.geoServerQueryPost(
        this.contextData.urlL,
        where,
        this.$olmap
      );
      // this.pagetotal = pjsonResult.resultData.totalFeatures; //总条数复制
      this.pageinfo.count = pjsonResult.resultData.totalFeatures; //总条数复制
      if (this.pageinfo.count === 0) {
        this.$Message.warning('查询结果为空');
        return;
      }
      this.dataparam_exp = JSON.parse(JSON.stringify(where)); //查询条件
      this.spinshow = false;
      if (
        pjsonResult.resultData &&
        pjsonResult.resultData.features &&
        pjsonResult.resultData.features.length > 0
      ) {
        this.getDataShow(pjsonResult.featureArr, this.contextData, this.pageinfo.count);
      } else {
        this.$Message.info('暂无数据!');
      }
    },
    // 当前行选中 -双击事件
    ondbrowclick(data, index) {
      this.$bus.emit('DrawingAndDocumentManagementfileFieldId', data.gid); // 传给图档管理的id
      var extent = this.Featurecollection[index].getGeometry().getExtent(); //获取一个坐标数组的边界，格式为[minx,miny,maxx,maxy]
      var center = ol.extent.getCenter(extent); //获取边界区域的中心位置
      this.olmap.getView().animate({
        center: center,
        zoom: 16,
      });
      // 获取当前层级
      this.olmap.zxQueryLayer.getSource().forEachFeature(fea => {
        fea.setStyle(
          new ol.style.Style({
            stroke: new ol.style.Stroke({
              color: 'rgba(0, 0, 255, 0.8)',
              width: 2,
            }),
            fill: new ol.style.Fill({
              color: 'rgba(255, 255, 255, 0.2)', //填充颜色
            }),
          })
        );
      });
      this.Featurecollection[index].setStyle(
        new ol.style.Style({
          stroke: new ol.style.Stroke({
            color: 'rgba(255, 0, 0, 1)',
            width: 3,
          }),
          fill: new ol.style.Fill({
            color: 'rgba(255, 255, 255, 0.1)', //填充颜色
          }),
        })
      );
      let geometry = this.Featurecollection[index].values_.geometry;
      this.Featurecollection[index].values_ = data;
      this.Featurecollection[index].values_.geometry = geometry;
      // 然后去找showpop_map事件
      this.$emit('showpop_map', this.Featurecollection[index]);
    },
    // 当前行选中 -单击事件
    onrowclick(data, index) {
      let that = this;
      var extent = this.Featurecollection[index].getGeometry().getExtent(); //获取一个坐标数组的边界，格式为[minx,miny,maxx,maxy]
      var center = ol.extent.getCenter(extent); //获取边界区域的中心位置
      this.olmap.getView().setCenter(center); //设置当前地图的显示中心位置
      this.olmap.zxQueryLayer.getSource().forEachFeature(function (fea) {
        fea.setStyle(
          new ol.style.Style({
            stroke: new ol.style.Stroke({
              color: 'rgba(0, 0, 255, 0.8)',
              width: 2,
            }),
            fill: new ol.style.Fill({
              color: 'rgba(255, 255, 255, 0.2)', //填充颜色
            }),
          })
        );
      });

      var cnv = document.createElement('canvas');
      var ctx = cnv.getContext('2d');
      var img = new Image();
      img.src = '../../../static/img/fill.png';
      img.onload = function () {
        var pattern = ctx.createPattern(img, 'repeat');

        that.Featurecollection[index].setStyle(
          new ol.style.Style({
            stroke: new ol.style.Stroke({
              color: 'rgba(255, 0, 0, 1)',
              width: 3,
            }),
            fill: new ol.style.Fill({
              color: pattern,
            }),
          })
        );
        // vector.setStyle(new ol.style.Style({
        //     stroke: new ol.style.Stroke({
        //         color: 'red',
        //         lineDash: [5],
        //         width: 2
        //     }),
        //     fill: new ol.style.Fill({
        //         color: pattern
        //     })
        // }));
      };
    },
    getDataShow_analysis(data, currentLayer, total) {
      if (data.length < 1) {
        this.columns1 = [];
        this.data134 = [];
        var source = this.olmap.zxQueryLayer.getSource();
        this.pageinfo.count = 0;
        source.clear();
        return;
      }
      this.pageinfo.count = total;
      this.contextData = currentLayer;
      this.Featurecollection = [];
      var FeatureAllTotal = {
        type: 'FeatureCollection',
        crs: { type: 'name', properties: { name: 'urn:ogc:def:crs:OGC:1.3:CRS84' } },
        features: [],
      };
      var source = this.olmap.zxQueryLayer.getSource();
      source.clear();
      let columns = [];
      columns = [
        {
          title: '序号',
          type: 'index',
          width: 70,
          align: 'center',
          fixed: 'left',
        },
      ];
      let dataArr = [];
      // 判断是否是专题分析，直接返回总数
      for (var d = 0; d < data.length; d++) {
        var type = data[d].geometryType;
        var attributesObj = data[d].values_;
        var cc = {};
        Object.keys(attributesObj).forEach(function (key) {
          if (key != 'geometry') {
            if (d == 0) {
              var col = {
                title: key.toString(),
                key: key.toString(),
                width: 100,
                align: 'center',
              };
              columns.push(col);
            }
            const hasDot = function (num) {
              if (!isNaN(num)) {
                return (num + '').indexOf('.') != -1 ? true : false;
              }
            };
            if (hasDot(attributesObj[key])) {
              // 数字
              attributesObj[key] = parseFloat(attributesObj[key]).toFixed(4); //小数点截取4位
            }
            cc[key] = attributesObj[key] || attributesObj[key] === 0 ? attributesObj[key].toString() : '';
          }
        });
        dataArr.push(cc);
      }
      var fieldsList = currentLayer.wfs && currentLayer.wfs.fields ? currentLayer.wfs.fields : {};
      if (fieldsList) {
        //获取设置别名的
        if (fieldsList.constructor != Array) {
          //当只有一个的时候
          var aa = [];
          aa.push(fieldsList);
          fieldsList = aa;
        }
        var fieldAlias = [];
        for (let f = 0; f < fieldsList.length; f++) {
          var fol = {
            key: fieldsList[f].key,
            title: fieldsList[f].alias,
            align: 'center',
          };
          fieldAlias.push(fol);
        }
      }
      // 取表头
      if (currentLayer.wfs && currentLayer.wfs.displayColms) {
        //是否有指定显示字段
        var displaycolms = currentLayer.wfs.displayColms.split(',');
        columns = [
          {
            title: '序号',
            type: 'index',
            width: 70,
            align: 'center',
            fixed: 'left',
          },
        ];
        for (let c = 0; c < displaycolms.length; c++) {
          if (fieldAlias) {
            var item = fieldAlias.find(item => item.key == displaycolms[c]);
            if (item) {
              var col = {
                title: item.title,
                key: item.key,
                align: 'center',
                minWidth: 70,
              };
              columns.push(col);
            } else {
              var col = {
                title: displaycolms[c],
                key: displaycolms[c],
                align: 'center',
                minWidth: 70,
              };
              columns.push(col);
            }
          } else {
            var col = {
              title: displaycolms[c],
              key: displaycolms[c],
              align: 'center',
              minWidth: 70,
            };
            columns.push(col);
          }
        }
        //最后加上压盖分析比例
        var anData = ['压占比', '图斑面积', '压占面积'];
        for (var a = 0; a < 3; a++) {
          var colm = {
            title: anData[a],
            key: anData[a],
            align: 'center',
            minWidth: 70,
          };
          columns.push(colm);
        }
      } else {
        //没有的话重合别名
        if (fieldAlias) {
          for (var f in fieldAlias) {
            var item = columns.find(item => item.key == fieldAlias[f].key);
            if (item) {
              item.title = fieldAlias[f].title;
            }
          }
        }
      }
      this.Featurecollection = data; //点击表格定位的json数据赋值
      this.data134 = dataArr;
      this.columns1 = columns;
      var source = this.olmap.zxQueryLayer.getSource();
      source.clear();
      source.addFeatures(data);
    },
    // 打开底部的弹框展示数据；
    getDataShow(Features, currentLayer, total) {
      // console.log("弹窗", currentLayer);
      let that = this;
      this.pageinfo.count = total;
      this.contextData = currentLayer;
      if (Features.length > 0) {
        let dataArr = [];
        let columns = [];
        columns = [
          {
            title: '序号',
            type: 'index',
            width: 70,
            align: 'center',
            fixed: 'left',
          },
        ];
        this.Featurecollection = [];
        this.Featurecollection = Features;
        for (let i = 0; i < Features.length; i++) {
          var cc = {};
          for (let items in Features[i].values_) {
            if (
              items != 'OBJECTID_1' &&
              items != 'SHAPE_1_Le' &&
              items != 'bbox' &&
              items != 'geometry' &&
              items != 'layerPDFid'
            ) {
              if (i == 0) {
                var col = {
                  title: items.toString(),
                  key: items.toString(),
                  minWidth: 100,
                  align: 'center',
                };
                columns.push(col);
              }
              const hasDot = function (num) {
                if (!isNaN(num)) {
                  return (num + '').indexOf('.') != -1 ? true : false;
                }
              };
              // 判断类型，时间类型转为时间格式
              if (that.totalField && that.totalField.length > 0) {
                for (var f = 0; f < that.totalField.length; f++) {
                  if (
                    items == that.totalField[f].name &&
                    that.totalField[f].type == 'esriFieldTypeDate'
                  ) {
                    if (Features[i].values_[items] && Features[i].values_[items] != 'null') {
                      Features[i].values_[items] = that.getdatachange(Features[i].values_[items]);
                    } else {
                      Features[i].values_[items] = '';
                    }
                  }
                }
              }
              if (hasDot(Features[i].values_[items])) {
                // 数字
                Features[i].values_[items] = parseFloat(Features[i].values_[items]).toFixed(4); //小数点截取4位
              }
              cc[items] = Features[i].values_[items] || Features[i].values_[items] === 0 ? Features[i].values_[items].toString() : '';
            }
          }
          dataArr.push(cc);
        }
        var fieldsList = currentLayer.wfs && currentLayer.wfs.fields ? currentLayer.wfs.fields : [];
        if (fieldsList) {
          //获取设置别名的
          if (fieldsList.constructor != Array) {
            //当只有一个的时候
            var aa = [];
            aa.push(fieldsList);
            fieldsList = aa;
          }
          var fieldAlias = [];
          for (let f = 0; f < fieldsList.length; f++) {
            var fol = {
              key: fieldsList[f].key,
              title: fieldsList[f].alias,
              minWidth: 100,
              align: 'center',
            };
            fieldAlias.push(fol);
          }
        }
        if (currentLayer.wfs && currentLayer.wfs.displayColms) {
          //是否有指定显示字段
          var displaycolms = currentLayer.wfs.displayColms.split(',');
          columns = [
            {
              title: '序号',
              type: 'index',
              width: 70,
              align: 'center',
              fixed: 'left',
            },
          ];
          for (let c = 0; c < displaycolms.length; c++) {
            if (fieldAlias) {
              var item = fieldAlias.find(item => item.key == displaycolms[c]);
              if (item) {
                var col = {
                  title: item.title,
                  key: item.key,
                  minWidth: 100,
                  align: 'center',
                };
                columns.push(col);
              } else {
                var col = {
                  title: displaycolms[c],
                  key: displaycolms[c],
                  align: 'center',
                  minWidth: 100,
                };
                columns.push(col);
              }
            } else {
              var col = {
                title: displaycolms[c],
                key: displaycolms[c],
                align: 'center',
              };
              columns.push(col);
            }
          }
        } else {
          //没有的话重合别名
          if (fieldAlias) {
            for (var f in fieldAlias) {
              var item = columns.find(item => item.key == fieldAlias[f].key);
              if (item) {
                item.title = fieldAlias[f].title;
              }
            }
          }
        }
        console.log(columns, dataArr, this.contextData, '666');
        // 增加档案数据的 判断交互
        if (this.contextData.businessData) {
          var objData = JSON.parse(this.contextData.businessData);
          if (objData.hasOwnProperty('fudzNote') && objData.fudzNote) {
            columns.push({
              title: '操作',
              slot: 'action',
              width: 90,
              align: 'center',
              fixed: 'right',
            });
          }
        }
        this.columns1 = columns; //表头
        this.data134 = dataArr;
      } else {
        this.columns1 = [];
        this.data134 = [];
      }
      var source = this.olmap.zxQueryLayer.getSource();
      source.clear();
      source.addFeatures(Features);
    },
    //点击查看的按钮
    lookBusinessData(row, type) {
      var objData = JSON.parse(this.contextData.businessData);
      var selectList = JSON.parse(JSON.stringify(objData.selectList));
      var url = objData.fudzNote;
      for (let i = 0; i < selectList.length; i++) {
        selectList[i].codeValue = row[selectList[i].value];
        selectList[i].labelNew = '{' + selectList[i].label + '}';
        if (url.indexOf(selectList[i].labelNew) != -1) {
          url = url.replace('{' + selectList[i].label + '}', selectList[i].codeValue);
        }
      }
      window.open(url);
    },
    /**
     * @author zt
     * @date 2020-08-20
     * @description 显示全部高亮的数据
     */
    closeexport() {
      this.showStatus = true;
      var arr = this.olmap.getLayers().array_;
      var curid = this.contextData.id; //当前选中图层的id
      for (var i = arr.length - 1; i >= 0; i--) {
        var layer = arr[i];
        var id = layer.get('id');
        if ('_layertree_' + curid == id) {
          // 进行出图操作
          this.publicMethod.filterGeoServerLayer(layer, '1=1');
          break;
        }
      }
    },
    /**
     * @author zt
     * @date 2020-08-20
     * @description 显示符合条件的数据
     */
    filterexport() {
      var curid = this.contextData.id; //当前选中图层的id
      // 先移除，再添加
      var postData = JSON.parse(JSON.stringify(this.dataparams));
      if (this.filtercondition.Where == '' && postData.where == '1=1' && postData.geometry == '') {
        this.showStatus = true;
        this.$Message.info('当前图层并无过滤条件！');
        return;
      }
      if (this.filtercondition.Where != '') {
        this.showStatus = false;
        // 二次过滤条件非空
        if (postData.where == '1=1') {
          postData.where = this.filtercondition.Where;
        } else {
          if (postData.where) {
            postData.where += ' And '; //且
            postData.where += this.filtercondition.Where;
          } else {
            postData.where = this.filtercondition.Where;
          }
        }
      } else {
        this.$Message.info('请设置二次过滤条件!')
        return;
      }
      var arr = this.olmap.getLayers().array_;
      for (var i = arr.length - 1; i >= 0; i--) {
        var layer = arr[i];
        var id = layer.get('id');
        if ('_layertree_' + curid == id) {
          // 进行出图操作
          var params = layer.getSource().getParams();
          var where1 = {};
          var layerlengedid = this.contextData.layerId ? this.contextData.layerId : 0;
          var def = layerlengedid || layerlengedid == 0 ? layerlengedid : params.layers;
          where1 = postData.where;
          params['CQL_FILTER'] = where1;
          layer.getSource().updateParams(params);
          break;
        }
      }
    },
    /**
     * @author zt
     * @date 2020-08-15
     * @description 二次过滤
     */
    oncefilter() {
      this.filtershow = true;
      this.data_filter = [];
      this.data_val = [];
      // 清空之前的二次过滤条件
      this.filtercondition.fild = '';
      this.filtercondition.operator = '';
      this.filtercondition.value = '';
      this.filtercondition.type = '';
      // this.filtercondition.Where = '';
      if (
        !this.filtercondition.layerfilterid ||
        this.filtercondition.layerfilterid != this.contextData.id
      ) {
        this.filtercondition.Where = '';
      }
      if (this.queryType) {
        let that = this;
        // http://192.168.1.113:8889/geoserverplugin/wps/getAttribute
        $.ajax({
          type: 'post',
          url: '/zituSpace/wps/getAttribute',
          // dataType: 'json',
          contentType: 'application/json; charset=UTF-8',
          data: JSON.stringify({ indicate: this.dataparams.indicate }),
          success: function (res) {
            if (res.code == 200 && res.success) {
              that.data_filter = res.result.classificationValue;
            }
          },
          error: function (e) { },
        });
      } else {
        // 当前选中的图层
        var fieldParam = {
          service: 'WFS',
          version: '1.0.0',
          request: 'DescribeFeatureType',
          typeName: this.contextData.layername,
          outputFormat: 'application/json',
          maxFeatures: 1,
        };
        this.getFieldsByLayerName(this.contextData.url, fieldParam, this.contextData); //geoServer
      }
    },

    /**
     * @author ss
     * @date 2020-11-15
     * @description 无关查询的导出
     */
    exportresultNoRelation() {
      // this.FeatureAll
      var tot = this.pageinfo.count; //当前的总条数
      if (tot < 1) {
        this.$Message.info('当前没有可导出的数据');
        return;
      }
      this.exportloading = true;
      var datalist1 = [];
      var columns1 = JSON.parse(JSON.stringify(this.columns1));
      this.$refs.table_property.exportCsv({
        filename: '属性表',
        columns: columns1.slice(1), //不要 序号 字段
        data: this.data134,
      });
      this.exportloading = false;
    },
    /**
     * @author zt
     * @date 2020-1208
     * @description 批而未供等保存图层
     */
    saveresult() {
      let that = this;
      var tot = this.pageinfo.count; //当前的总条数
      if (tot < 1) {
        this.$Message.info('当前没有可保存的数据');
        return;
      }
      this.savelayerstatus.loading = true;
      var param = JSON.parse(JSON.stringify(this.dataparams)); //深度复制
      this.FeatureAll = propertySearch(this.contextData, param, tot);
    },

    /**
     * @author qqjuanqq
     * @date 2020-12-18
     * @description 导出查询结果-最新修改
     */
    /*
     *@description:
     *@author: Fengxy
     *@date: 2023-04-19 13:56:53
     *@version: V1.0.5
     */
    exportresult() {
      this.outPutFileParams.id = this.dataparams.id;
      this.outPutFileParams.url = this.dataparams.bufferUrl;
      this.outPutFileParams.layername = this.dataparams.layername;
      // 拼接数据参数filter
      if (this.filtercondition.Where) {
        if (this.dataparams.where) {
          this.outPutFileParams.cql = this.dataparams.where + ' ' + 'And' + ' ' + this.filtercondition.Where;
        } else {
          this.outPutFileParams.cql = this.filtercondition.Where;
        }
      } else {
        if (this.dataparams.where) {
          this.outPutFileParams.cql = this.dataparams.where
        } else {
          this.outPutFileParams.cql = ''
        }
      }
      let that = this;
      outPutSearchInfo(this.outPutFileParams).then(res => {
        const blob = res;
        var url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', '导出查询结果.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        that.$Message.success('导出成功');
      });
    },
    /**
     * @author zt
     * @date 2020-08-15  现有项目分布模块导出的按钮
     * @description 通用导出查询结果excel
     */
    exportresult_common() {
      if (this.onlyExport) {
        //现有项目分布的导出
        this.exportloading = true;
        var columns1 = JSON.parse(JSON.stringify(this.columns1));
        this.$refs.table_property.exportCsv({
          filename: '项目分布属性表',
          columns: columns1.slice(1), //不要 序号 字段
          data: this.data134,
        });
        this.exportloading = false;
      } else {
        let that = this;
        var tot = this.pageinfo.count; //当前的总条数
        if (tot < 1) {
          this.$Message.info('当前没有可导出的数据');
          return;
        }
        this.exportloading = true;
        var param = JSON.parse(JSON.stringify(this.dataparams)); //深度复制
        this.FeatureAll = propertySearch(this.contextData, param, tot);
        var datalist1 = [];
        var columns1 = [];

        for (let i = 0; i < this.FeatureAll.length; i++) {
          var cc = {};
          for (let items in this.FeatureAll[i].properties) {
            if (i == 0) {
              // 判断是否有别名
              var title = items;
              for (var f = 0; f < that.fieldsList.length; f++) {
                if (items == that.fieldsList[f].key) {
                  title = that.fieldsList[f].alias
                    ? that.fieldsList[f].alias
                    : that.fieldsList[f].key;
                  break;
                }
              }
              var col = {
                title: title.toString(),
                key: items.toString(),
                width: 100,
                align: 'center',
              };
              columns1.push(col);
            }
            cc[items] = this.FeatureAll[i].properties[items]
              ? this.FeatureAll[i].properties[items].toString()
              : '';
          }
          datalist1.push(cc);
        }
        this.$refs.table_property.exportCsv({
          filename: '属性表',
          columns: columns1,
          data: datalist1.filter(function (data, index) {
            for (var c in data) {
              data[c] = that.handleStr(data[c]);
            }
            return data;
          }),
        });
        this.exportloading = false;
      }
    },

    /**
     * @author qqjuanqq
     * @date 2020-12-02
     * @description 导出shp结果
     */
    exportshp() {
      // this.FeatureAll
      console.log('this.dataparam_exp', this.dataparam_exp);
      let that = this;
      var tot = this.pageinfo.count; //当前的总条数
      if (tot < 1) {
        this.$Message.info('当前没有可导出的数据');
        return;
      }
      this.shploading = true;
      var param = JSON.parse(JSON.stringify(this.dataparam_exp)); //深度复制

      let Featureurl = shpSearch(this.contextData, param, tot);
      this.shploading = false;
      if (Featureurl && Featureurl.code == 200 && Featureurl.result != '') {
        var $a = $('<a></a>')
          .attr('href', Featureurl.result)
          .attr('download', ''); //下载
        $a[0].click();
      } else {
        this.$Message.info('导出失败');
        return;
      }
    },

    /**
     * @author  ss
     * @date 2020-12-20
     * @description 压盖分析导出结果
     */
    exportresultYGAnalysis() {
      // var params = {
      //   layers: [],
      //   pointStr: JSON.stringify(this.dataparams.pointStr),
      //   resultOffset: 0,//分页功能
      //   resultRecordCount: 5000,
      //   sr: appConfig.map.proj.split(":")[1],
      //   geometriesParams: JSON.stringify(this.dataparams.geometriesParams),
      // }
      // this.exportloading = true;
      // if (this.dataSelect.length > 0) {
      //   for (var i = 0; i < this.dataSelect.length; i++) {
      //     var layer = {
      //       layerName: this.dataSelect[i].layername,
      //       pdfField: this.dataSelect[i].wfs.pdfField,
      //       title: this.dataSelect[i].title,
      //       displayColms: this.dataSelect[i].wfs.displayColms,
      //       layerId: this.dataSelect[i].layerId ? this.dataSelect[i].layerId : 0,
      //       fields: this.contextData.wfs.fields
      //     };
      //     params.layers.push(layer);
      //   }
      // } else {
      //   var layer = {
      //     layerName: this.contextData.layername,
      //     pdfField: this.contextData.wfs.pdfField,
      //     title: this.contextData.title,
      //     displayColms: this.contextData.wfs.displayColms,
      //     layerId: this.contextData.layerId ? this.contextData.layerId : 0,
      //     fields: this.contextData.wfs.fields
      //   };
      //   params.layers.push(layer);
      // }
      this.exportloading = true;
      setTimeout(() => {
        var params = {
          typeName: this.contextData.layername,
          maxFeatures: 10000000,
          coordinates: JSON.stringify(this.dataparams.pointStr),
          url: this.contextData.bufferUrl,
          geometriesParams: JSON.stringify({
            type: 'MultiPolygon',
            coordinates: [
              this.dataparams.jsonData
                ? this.dataparams.jsonData
                : this.dataparams.geometriesParams.rings,
            ],
          }),
          bufferNumber: '',
          sr: appConfig.map.proj,
          layers: JSON.stringify(this.contextData),
          fileId: this.dataparams.fileId ? this.dataparams.fileId : ''
        };
        exportTYExcel(params).then(res => {
          this.exportloading = false;
          if (res) {
            var blob = new Blob([res], { type: 'application/msexcel;charset=utf-8' });
            var href = window.URL.createObjectURL(blob); //创建下载的链接
            var $a = $('<a></a>')
              .attr('href', href)
              .attr('download', '分析结果.xls'); //下载
            $a[0].click();
          } else {
            this.$Message.warning('导出失败');
          }
        });
      });
    },

    handleStr(str) {
      let handleStr = str.replace(/[\r\n]/g, '');
      //先判断字符里是否含有逗号
      if (str.indexOf(',') != -1) {
        //如果还有双引号，先将双引号转义，避免两边加了双引号后转义错误
        if (str.indexOf('"') != -1) {
          handleStr = str.replace('"', '""');
        }
        //将逗号转义
        handleStr = '"' + handleStr + '"';
        return handleStr;
      }

      // 判断是否是数字类型
      if (str && str !== '') {
        if (typeof str === 'number' && !isNaN(str)) {
          handleStr = '\t' + str;
          return handleStr;
        }
      }
      return '"' + handleStr + '"';
    },
    // 二次过滤条件  运算符
    filtertj(item, index) {
      this.filtercondition.operator = item;
      // var fild = this.filtercondition.fild;
      // var operator = this.filtercondition.operator;
      // var value = this.filtercondition.value;
      // this.filtercondition.Where = '';
      // //  拼字段
      // if (this.filtercondition.type == 'esriFieldTypeString') {
      //   value = "'" + value.trim() + "'";
      // }
      // if (operator == 'like') {
      //   this.filtercondition.Where += fild + ' ' + operator + ' ' + "'%" + value + "%'";
      // } else {
      //   this.filtercondition.Where += fild + operator + value;
      // }
      if (item == '空') {
        this.filtercondition.Where = `${this.filtercondition.Where} null`;
      } else if (item == '非空') {
        this.filtercondition.Where = `${this.filtercondition.Where} is not null`;
      } else {
        this.filtercondition.Where = this.filtercondition.Where + ' ' + item;
      }
    },
    // 二次过滤表格字段获取单机事件
    filterVal(data, index) {
      if (this.filtercondition.operator == 'like') {
        this.filtercondition.Where = this.filtercondition.Where + ' ' + "'%" + `${data.val}` + "%'";
      } else {
        this.filtercondition.Where = this.filtercondition.Where + ' ' + `'${data.val}'`;
      }
      // this.filtercondition.value = data.val;
      // var fild = this.filtercondition.fild;
      // var operator = this.filtercondition.operator;
      // var value = this.filtercondition.value;
      // this.filtercondition.Where = '';
      // //  拼字段
      // if (this.filtercondition.type == 'esriFieldTypeString') {
      //   value = "'" + value.trim() + "'";
      // }
      // if (operator == 'like') {
      //   this.filtercondition.Where += fild + ' ' + operator + ' ' + "'%" + value + "%'";
      // } else {
      //   this.filtercondition.Where += `${fild}${operator}'${value}'`;
      // }
    },
    // 二次过滤表格获取双击事件 data-当前行的数据
    filterfield(data, index) {
      this.spintj = true;
      // this.filtercondition.fild = data.name;
      // this.filtercondition.type = data.type;
      // this.filtercondition.operator = '';
      // this.filtercondition.value = '';
      // var fild = this.filtercondition.fild;
      // var operator = this.filtercondition.operator;
      // var value = this.filtercondition.value;
      //  拼字段
      // if (this.filtercondition.type == 'esriFieldTypeString') {
      //   value = "'" + value.trim() + "'";
      // }
      // if (operator == 'like') {
      //   this.filtercondition.Where += fild + ' ' + operator + ' ' + "'%" + value + "%'";
      // } else {
      //   this.filtercondition.Where += `${fild}${operator}'${value}'`;
      // }
      // change by  qqjuanqq
      if (this.filtercondition.Where) {
        this.filtercondition.Where = this.filtercondition.Where + ' ' + data.name;
      } else {
        this.filtercondition.Where = this.filtercondition.Where + data.name;
      }
      if (this.queryType) {
        let that = this;
        var params = {
          indicate: this.dataparams.indicate,
          classificationField: data.name,
        };
        $.ajax({
          type: 'post',
          url: '/zituSpace/wps/getClassificationValue',
          contentType: 'application/json; charset=UTF-8',
          data: JSON.stringify(params),
          success: function (res) {
            if (res.code == 200 && res.success) {
              that.spintj = false;
              that.data_val = [];
              res.result.classificationValue.length > 0 &&
                res.result.classificationValue.forEach(item => {
                  that.data_val.push({
                    val: item.groupcount,
                  });
                });
            }
          },
          error: function (e) { },
        });
      } else {
        this.geoGetUniqueList(data, index); //mapgis
      }
    },
    // mapgis 根据属性查询属性值的接口；
    async geoGetUniqueList(data, index) {
      var typeName = this.contextData.layername;
      var strName = data.name;
      let res = await this.publicMethod.getattributeValue(typeName, strName);
      if (res) {
        this.data_val = [];
        this.spintj = false;
        var codeStr = this.xmlStr2XmlObj(res);
        var xmlArr = codeStr
          .getElementsByTagName('wfs:FeatureCollection')[0]
          .getElementsByTagName('feature:featureMember');
        xmlArr.length > 0 &&
          xmlArr.forEach((item, index) => {
            var value = item
              .getElementsByTagName('feature:UniqueValue')[0]
              .getElementsByTagName('feature:value')[0].innerHTML;
            this.data_val.push({
              val: value,
            });
          });
      }
    },
    xmlStr2XmlObj(xmlStr) {
      var xmlObj = {};
      if (document.all) {
        var xmlDom = new ActiveXObject('Microsoft.XMLDOM');
        xmlDom.loadXML(xmlStr);
        xmlObj = xmlDom;
      } else {
        xmlObj = new DOMParser().parseFromString(xmlStr, 'text/xml');
      }
      return xmlObj;
    },

    //获取图层属性字段列表
    getFieldsByLayerName(url, fieldParam, contextData) {
      var that = this;
      $.ajax({
        type: 'get',
        async: false, //同步
        url: url,
        data: fieldParam,
        success: function (data) {
          if (contextData.type == 'layer.VectorgeoServeRest') {
            var arrOne = data.featureTypes[0].properties;
            var arrTwo = contextData.wfs.fields;
            arrOne.length > 0 &&
              arrOne.forEach((item, index) => {
                arrTwo.length > 0 &&
                  arrTwo.forEach((itema, indea) => {
                    if (item.name == itema.key) {
                      item.alias = itema.alias;
                    }
                  });
              });
            //geoServer方式
            that.data_filter = arrOne;
          } else {
            that.data_filter = JSON.parse(data).fields;
          }
        },
        error: function (e) {
          that.$Message.info('获取字段信息失败');
        },
      });
    },
    async queryArcGISRest(resetnull) {
      if (!this.contextData || !this.contextData.urlL) {
        this.applyloading = false;
        return;
      }
      var postData = JSON.parse(JSON.stringify(this.dataparams));
      console.log('this.dataparams', this.dataparams);
      if (!resetnull) {
        if (postData.where == '1=1') {
          postData.where = this.filtercondition.Where;
        } else {
          if (postData.where) {
            postData.where += ' And '; //且
            postData.where += this.filtercondition.Where;
          } else {
            postData.where = this.filtercondition.Where;
          }
        }
      }
      //addby qqjuanqq 最新通用geoServerQuery查询方法
      postData.CqlFilter = postData.where; //geoserver处理查询条件
      var pjsonResult = await this.publicMethod.geoServerQueryPost(
        this.contextData.urlL,
        postData,
        this.$olmap
      ); //通用查询方法
      if (!pjsonResult.flagSearch) {
        this.$Message.info("查询失败,请检查参数!")
        this.applyloading = false;
        return;
      }
      this.applyloading = false;
      this.pageinfo.current = 1;
      this.showStatus = false;
      // this.pagetotal = pjsonResult.resultData.totalFeatures; //总条数赋值
      this.filtershow = false;
      this.pageinfo.count = pjsonResult.resultData.totalFeatures; //总条数复制
      if (
        pjsonResult.resultData &&
        pjsonResult.resultData.features &&
        pjsonResult.resultData.features.length > 0
      ) {
        this.$Message.info('过滤成功!');
        this.getDataShow(pjsonResult.featureArr, this.contextData, this.pageinfo.count);
        // 设置当前图层进行过滤；
        var arr = this.olmap.getLayers().array_;
        var curid = this.contextData.id; //当前选中图层的id
        for (var i = arr.length - 1; i >= 0; i--) {
          var layer = arr[i];
          var id = layer.get('id');
          if ('_layertree_' + curid == id) {
            // 进行出图操作
            this.publicMethod.filterGeoServerLayer(layer, postData.where);
            break;
          }
        }
      } else {
        this.getDataShow([], this.contextData, 0);
        this.$Message.info('暂无数据!');
      }
      this.dataparam_exp = JSON.parse(JSON.stringify(postData)); //查询条件
    },
    // sql输入框进行查询
    apply() {
      if (this.filtercondition.Where) {
        this.applyloading = true;
        if (this.queryType) {
          let that = this;
          this.dataparams.queryParam = this.filtercondition.Where;
          $.ajax({
            type: 'post',
            url: '/zituSpace/wps/getGeoserverQuery',
            contentType: 'application/json; charset=UTF-8',
            data: JSON.stringify(this.dataparams),
            success: function (res) {
              if (res.code == 200 && res.success) {
                that.applyloading = false;
                that.showStatus = false;
                that.filtershow = false;
                let featureArr = [];
                if (res.result.features.length > 0) {
                  res.result.features.forEach((item, index) => {
                    var geojson_format = new that.$olmap.format.GeoJSON();
                    let featureObj = geojson_format.readFeature(item.geometry);
                    featureObj.values_ = Object.assign(featureObj.values_, item.properties);
                    featureArr.push(featureObj);
                  });
                }
                if (featureArr.length > 0) {
                  that.pagetotal = res.result.totalFeatures;
                  that.pageinfo.count = res.result.totalFeatures; //总条数
                  that.getDataShow(featureArr, that.contextData, that.pageinfo.count);
                } else {
                  that.$Message.info('暂无数据！');
                }
              }
            },
            error: function (e) { },
          });
        } else {
          this.filtercondition.layerfilterid = this.contextData.id;
          this.queryArcGISRest();
        }
      } else {
        this.$Message.info('请填写查询语句！');
      }
    },
    // sql输入框清空
    clear() {

      console.log('输出sql语句', this.filtercondition.Where);
      this.filtercondition.fild = '';
      this.filtercondition.operator = '';
      this.filtercondition.value = '';
      // this.filtercondition.Where = '';
      this.filtercondition.type = '';
      if (this.filtercondition.Where) {
        this.filtercondition.Where = '';
        this.$Message.success('清空成功')
        // this.queryArcGISRest('reset');
        // this.closeexport();
      }
    },
    /*
     *@description: sql验证操作
     *@author: qqjuanqq
     *@date: 2023-04-26 10:58:15
     *@version: V1.0.0
    */
    testVerify() {
      if (!this.filtercondition.Where) {
        this.$Message.info("请先选择过滤条件在进行验证!")
      }
      var param = {
        cqlFilter: this.filtercondition.Where
      }
      getCheckSql(param).then(res => {
        if (res.code == 200 && res.success) {
          this.$Message.info("验证成功!")
        } else {
          this.$Message.info("验证失败，请修改!")
        }
      }).catch(err => {
        this.$Message.info("验证失败，请修改!")
      })
    },
    /**
     * 上传新增feature数据
     * wh
     * start
     */
    //获取所有字段
    getAllProperty() {
      let that = this;
      let url = this.contextData.urlL + '?f=pjson';
      $.ajax({
        type: 'get',
        url: url,
        async: false,
        success: function (resData) {
          resData = JSON.parse(resData);
          if (null != resData) {
            let fields = resData.fields;
            if (null != fields && fields.length > 0) {
              that.propertyArr = [];
              that.columns2 = [];
              for (let i = 0; i < fields.length; i++) {
                that.propertyArr.push(fields[i].name);
                that.columns2.push({
                  title: fields[i].name,
                  key: fields[i].name,
                  slot: fields[i].name,
                  width: 100,
                  align: 'center',
                });
              }
            }
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.log('连接数据的时候出现了：' + textStatus);
        },
      });
    },
    //shp上传
    shpBeforupload(file) {
      if (file.name.indexOf('.shp') == -1) {
        this.$Message.info('请上传shp文件');
      } else {
        this.readShpFile(file);
      }
      return false;
    },
    readShpFile(shpFile) {
      var that = this;
      this.getAllProperty();
      let currentGeometryType = 'esriGeometryPolygon';
      let fileReader = new FileReader();
      fileReader.readAsArrayBuffer(shpFile);
      fileReader.onload = function () {
        let shapefile = require('shapefile');
        shapefile.read(this.result).then(geoJson => {
          var geojson_format = new that.$olmap.format.GeoJSON();
          var shpfeatures = geojson_format.readFeatures(geoJson);
          that.drawGrid.polygonWKT = shpfeatures.length > 1 ? [] : '';
          that.drawGrid.polygonJson = [];
          for (var f = 0; f < shpfeatures.length; f++) {
            var gType = shpfeatures[f].getGeometry().getType();
            if (shpfeatures.length > 1) {
              that.drawGrid.polygonWKT.push(
                new that.$olmap.format.WKT().writeGeometry(shpfeatures[f].getGeometry(), {})
              ); //上传的shp是多个面
            } else {
              that.drawGrid.polygonWKT = new that.$olmap.format.WKT().writeGeometry(
                shpfeatures[f].getGeometry(),
                {}
              );
            }
            switch (gType) {
              case 'Polyline':
                currentGeometryType = 'esriGeometryPolyline';
                break;
              case 'Point':
                currentGeometryType = 'esriGeometryPoint';
                break;
              case 'Polygon':
                currentGeometryType = 'esriGeometryPolygon';
                break;
            }
            that.drawGrid.geometry = shpfeatures[f].getGeometry();
            that.drawGrid.polygonJson.push(shpfeatures[f].getGeometry().getCoordinates()[0]);
            that.addTableData.push({
              type: currentGeometryType,
            });
          }
          that.drawGrid.feature = shpfeatures;
          that.addShow = true;
          that.onrowclickAdd(); //绘制出来
          // that.initSource(shpfeatures);
        });
      };
    },

    //点击 新增的feature
    onrowclickAdd(data, index) {
      let shpfeatures = this.drawGrid.feature;
      this.olmap.zxQueryLayer.getSource().forEachFeature(function (fea) {
        fea.setStyle(
          new ol.style.Style({
            stroke: new ol.style.Stroke({
              color: 'rgba(0, 0, 255, 0.8)',
              width: 2,
            }),
            fill: new ol.style.Fill({
              color: 'rgba(255, 255, 255, 0.2)', //填充颜色
            }),
          })
        );
      });
      if (index || index == 0) {
        var extent = shpfeatures[index].getGeometry().getExtent(); //获取一个坐标数组的边界，格式为[minx,miny,maxx,maxy]
        var center = ol.extent.getCenter(extent); //获取边界区域的中心位置
        this.olmap.getView().setCenter(center); //设置当前地图的显示中心位置

        shpfeatures[index].setStyle(
          new ol.style.Style({
            stroke: new ol.style.Stroke({
              color: 'rgba(255, 0, 0, 1)',
              width: 3,
            }),
            fill: new ol.style.Fill({
              color: 'rgba(255, 255, 255, 0.1)', //填充颜色
            }),
          })
        );
      } else {
        var source = this.olmap.zxQueryLayer.getSource();
        source.addFeatures(shpfeatures);
        shpfeatures.forEach(fea => {
          fea.setStyle(
            new ol.style.Style({
              stroke: new ol.style.Stroke({
                color: 'rgba(0, 0, 255, 0.8)',
                width: 2,
              }),
              fill: new ol.style.Fill({
                color: 'rgba(255, 255, 255, 0.1)', //填充颜色
              }),
            })
          );
        });
      }
    },
    getdatachange(data) {
      var timestamp4 = '';
      var date = new Date(data);
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      let D = date.getDate() + ' ';
      // let h = date.getHours() + ':';
      // let m = date.getMinutes() + ':';
      // let s = date.getSeconds();
      // timestamp4 = Y+M+D+h+m+s;
      timestamp4 = Y + M + D;
      return timestamp4;
    },
    /** wh end */
  },
  mounted() {
    let that = this;
    this.$bus.off('spinShow');
    this.$bus.on('spinShow', value => {
      // 获取查询结果
      if (value) {
        that.bottomShow = true;
        that.spinshow = true;
      } else {
        that.bottomShow = false;
        that.spinshow = false;
      }
    });
    this.$bus.off('queryData');
    this.$bus.on('queryData', value => {
      this.hidebottom = false; //展开
      // 获取查询结果
      this.pageinfo.current = 1;
      that.olmap.distinguish = false; //关闭识别功能
      // 样式修改识别
      $('.distin .icon').css('background-image', 'url(../../../static/img/tool/distin_un.png)');
      $('.distin .li-span').css('color', '#333');
      this.$bus.emit('closeDistin', null);
      if (!value || value == null) {
        that.spinshow = false;
        that.bottomShow = false;
        return;
      }
      if (value.queryType) {
        this.queryType = value.queryType;
      } else {
        this.queryType = '';
      }
      this.filtercondition.Where = '';
      that.spinshow = false;
      this.analysis = value.analysis ? value.analysis : false;
      this.analysisdl = false;
      this.onlyExport = false;
      this.onlyExportxzjc = false;
      this.dataparams = null;
      this.isClose = true;
      this.titles = value.contextData.title; //查询标题显示
      this.dataparams = value.dataparam; //查询条件
      this.dataparam_exp = value.dataparam; //查询条件
      this.dataSelect = [];
      // 判断是否有别名
      this.fieldsList =
        value.contextData.wfs && value.contextData.wfs.fields ? value.contextData.wfs.fields : [];
      if (this.fieldsList) {
        //获取设置别名的
        if (this.fieldsList.constructor != Array) {
          //当只有一个的时候
          var aa = [];
          aa.push(this.fieldsList);
          this.fieldsList = aa;
        }
      }
      if (value.analysis) {
        //通用压盖分析
        // 压盖分析结果
        this.analysis = true;
        this.getDataShow_analysis(value.features, value.contextData, value.total);
        this.dataSelect = value.seleclData;
        this.currentChoose = value.contextData.id;
      } else if (value.analysisdl) {
        //国土空间专题分析
        this.analysisdl = true;
        this.getDataShow_analysis(value.features, value.contextData, value.total);
      } else {
        if (value.onlyExport) {
          this.onlyExport = true;
        }
        if (value.onlyExportxzjc) {
          //现状检测
          this.onlyExportxzjc = true;
        }
        if (value.noRelation) {
          this.noRelation = true;
        }
        if (value.savelayerstatus) {
          this.savelayerstatus.status = true;
        } else {
          this.savelayerstatus.status = false;
        }
        if (value.isClose) {
          this.isClose = false;
        }
        if (value.totalField) {
          this.totalField = value.totalField;
        }
        that.getDataShow(value.features, value.contextData, value.total); //接口支持分页查询
      }
      var codeArr = [];
      var codeNewArr = [];
      var ssArr =
        value.contextData.wfs && value.contextData.wfs.fields ? value.contextData.wfs.fields : [];
      // 根据当前的table的字段处理气泡显示的字段； qqjuanqq  2021-07-12
      for (let i = 0; i < this.columns1.length; i++) {
        codeArr.push({
          alias: this.columns1[i].title,
          name: this.columns1[i].key,
          type: 'esriFieldTypeOID',
        });
      }
      for (let i = 0; i < ssArr.length; i++) {
        for (let j = 0; j < codeArr.length; j++) {
          if (ssArr[i].key == codeArr[j].name) {
            codeNewArr.push(ssArr[i]);
          }
        }
      }
      // value.totalField = codeArr; //总共的字段赋值 qqjuanqq  2021-07-12
      // value.contextData.wfs.fields = codeNewArr; //处理wfs里面的数据 qqjuanqq  2021-07-12
      this.$emit('current_map', value.contextData, 1);
      // 处理图层的显示与影藏  addby  qqjuanqq  2022-9-9
      var arr = this.olmap.getLayers().array_;
      var curid = value.contextData.id; //当前选中图层的id
      for (var i = arr.length - 1; i >= 0; i--) {
        var layer = arr[i];
        var id = layer.get('id');
        if ('_layertree_' + curid == id) {
          // 进行出图操作
          if (value.dataparam.CqlFilter) {
            this.publicMethod.filterGeoServerLayer(layer, value.dataparam.CqlFilter);
          }
          break;
        }
      }
    });
    this.$bus.on('closebottom', value => {
      this.bottomRemoveClick();
    });
  },
};



// WEBPACK FOOTER //
// ./src/view/Bottomshow/BottomProperty.js